import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './components/Header';
import SideBar from './components/SideBar';
import VerifyEmailBanner from './components/VerifyEmailBanner';
import styles from './Home.module.css';

const VERIFY_MSG = {
  ok: { kind: 'ok', text: '✅ 이메일 인증이 완료되었습니다.' },
  invalid_or_expired: { kind: 'warn', text: '⚠️ 링크가 만료되었거나 유효하지 않습니다. 메일을 다시 보내주세요.' },
  missing_token: { kind: 'warn', text: '⚠️ 인증 토큰이 없습니다.' },
};

export default function Home() {
  const [params, setParams] = useSearchParams();
  const verifyParam = params.get('verify');
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    if (!verifyParam) return;
    const msg = VERIFY_MSG[verifyParam];
    if (msg) setFlash(msg);
    const next = new URLSearchParams(params);
    next.delete('verify');
    setParams(next, { replace: true });
  }, [verifyParam, params, setParams]);

  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.layout}>
        <SideBar />
        <main className={styles.main}>
          <VerifyEmailBanner />
          {flash && (
            <div className={`${styles.flash} ${flash.kind === 'ok' ? styles.flashOk : styles.flashWarn}`}>
              <span>{flash.text}</span>
              <button className={styles.flashClose} onClick={() => setFlash(null)} aria-label="닫기">×</button>
            </div>
          )}

          <h1 className={styles.welcome}>
            Welcome to InHence + Social,<br/>
            how can I help you?
          </h1>

          {/* 채팅 입력바: figma 디자인 마크업, 현재 hidden */}
          <div className={`${styles.chatBar} ${styles.hidden}`}>
            <button className={styles.sendButton} aria-label="Send" />
            <div className={styles.chatBarBottom}>
              <span>Suggested prompts</span>
            </div>
          </div>

          {/* 4개 snackbar 카드: figma 디자인 마크업, 현재 hidden */}
          <div className={`${styles.snackbarGrid} ${styles.hidden}`}>
            {[0, 1, 2, 3].map(i => (
              <div key={i} className={styles.snackbar}>
                <span>Two-line snackbar with longer action</span>
                <button className={styles.snackbarAction}>Action</button>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
